import { Grid, styled } from '@mui/material';

export const ErrorIconWrapper = styled(Grid)(({ theme }) => ({
  position: 'relative',
  right: theme.spacing(3.5),
  width: 0
}));
